/*
 * @function: 监听页面返回
*/
import { utils } from '@didi/webx-js-core';
const SHOW = 'show';
const HIDDEN = 'hidden';
function getHistoryPath() {
    const location = window.location;
    return location.origin + location.pathname;
}
function getHashPath(url) {
    let temporary = url;
    const searchIndex = temporary.indexOf('?');
    if (searchIndex > -1) {
        temporary = temporary.substr(0, searchIndex);
    }
    return temporary.substr(2);
}
function checkPath(options) {
    const { historyPath, hashPath } = options;
    const currentHistoryPath = getHistoryPath();
    const currentHashPath = getHashPath(window.location.hash || '#/index');
    if (historyPath && historyPath !== currentHistoryPath) {
        return false;
    }
    if (hashPath && hashPath !== currentHashPath) {
        return false;
    }
    return true;
}
function getPageStatus(status, cb) {
    let pageStatus = SHOW;
    document.addEventListener('visibilitychange', e => {
        if (document.hidden) {
            pageStatus = HIDDEN;
        }
        else {
            pageStatus = SHOW;
        }
        if (pageStatus === status) {
            cb(e);
        }
    });
    window.addEventListener('pagehide', e => {
        pageStatus = HIDDEN;
        if (pageStatus === status) {
            cb(e);
        }
    });
    window.addEventListener('pageshow', e => {
        if (pageStatus === SHOW) {
            return;
        }
        pageStatus = SHOW;
        if (pageStatus === status) {
            cb(e);
        }
    });
}
function spaPageShowCallBack(cb) {
    window.addEventListener('hashchange', () => {
        const hash = window.location.hash;
        if (!hash)
            return;
        cb();
    });
}
function pageShowCallBack(cb) {
    getPageStatus(SHOW, cb);
}
class AnimationFrame {
    constructor() {
        this.stop = false;
        this.startTime = 0;
        this.callback = null;
    }
    moveAnimation() {
        if (!this.startTime) {
            this.startTime = Date.now();
        }
        else {
            const now = Date.now();
            const interval = now - this.startTime;
            if (interval < 500) {
                this.startTime = now;
            }
            else {
                this.startTime = now;
                if (this.callback) {
                    this.callback();
                }
            }
        }
        if (!this.stop) {
            window.requestAnimationFrame(this.moveAnimation.bind(this));
        }
    }
    startAnimation(cb) {
        if (this.startTime)
            return;
        if (cb) {
            this.callback = cb;
        }
        try {
            this.stop = false;
            this.moveAnimation();
        }
        catch (_) {
            // 
        }
    }
    stopAnimation() {
        try {
            this.stop = true;
            this.startTime = 0;
            this.callback = null;
        }
        catch (_) {
            // 
        }
    }
}
class PageShowClass {
    constructor() {
        this.showListenerList = [];
        this.animation = new AnimationFrame();
        this._init();
        this.showCbTime = 0;
    }
    _init() {
        pageShowCallBack(this._onShowCallBack.bind(this));
        spaPageShowCallBack(this._onSpaShowCallBack.bind(this));
    }
    _onSpaShowCallBack() {
        if (!this.showListenerList.length)
            return;
        const list = this.showListenerList.slice();
        for (let index = 0; index < list.length; index++) {
            const item = list[index];
            const fn = item.cb;
            const { hashPath } = item.options;
            if (hashPath && checkPath(item.options)) {
                fn();
            }
        }
    }
    _onShowCallBack(e) {
        // 节流 时间为600ms， 防止同一时间触发多次
        const now = Date.now();
        if (!this.showCbTime) {
            this.showCbTime = now;
        }
        else if ((now - this.showCbTime) < 600) {
            return;
        }
        setTimeout(() => {
            this.showCbTime = 0;
        }, 700);
        if (!this.showListenerList.length)
            return;
        const list = this.showListenerList.slice();
        for (let index = 0; index < list.length; index++) {
            const item = list[index];
            const fn = item.cb;
            if (checkPath(item.options)) {
                fn(e);
            }
        }
    }
    on(fn, options = {}) {
        if (!fn)
            return;
        if (!utils.isFn(fn))
            return;
        this.animation.startAnimation(this._onShowCallBack.bind(this));
        const config = {};
        if (options.isHashPath) {
            const hash = window.location.hash;
            const hashPath = getHashPath(hash || '#/index');
            config.hashPath = hashPath;
        }
        if (options.isHistoryPath) {
            const historyPath = getHistoryPath();
            config.historyPath = historyPath;
        }
        this.showListenerList.push({
            cb: fn,
            options: config
        });
    }
    remove(fn) {
        if (!this.showListenerList.length)
            return true;
        let length = this.showListenerList.length;
        while (length--) {
            const cb = this.showListenerList[length].cb;
            if (cb === fn) {
                this.showListenerList.splice(length, 1);
            }
        }
        // 当没有监听事件时，停止动画
        if (this.showListenerList.length === 0) {
            this.animation.stopAnimation();
        }
        return true;
    }
    once(fn, options = {}) {
        let fired = false;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        function magic() {
            that.remove(magic);
            if (!fired) {
                fired = true;
                fn();
            }
        }
        this.on(magic, options);
    }
}
export default PageShowClass;
